export default __webpack_public_path__ + "static/media/109_desktop.b4b7f8b2.jpg";